import { useNavigate, useParams } from "react-router-dom";
import { AnalyticsLayout } from "../components/layout/AnalyticsLayout";
import { Spinner } from "../components/ui/Spinner";
import { useActivityByFile } from "../hooks/useActivity";
import { formatDateTime } from "../lib/format";

export function AnalyticsFilePage() {
  const navigate = useNavigate();
  const { fileId = "" } = useParams();
  const { data, isLoading, isError } = useActivityByFile(fileId);

  return (
    <AnalyticsLayout>
      <button
        type="button"
        onClick={() => navigate("/analytics")}
        className="text-body font-medium text-brand-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
      >
        ← Back to Analytics
      </button>

      {isLoading ? (
        <div className="mt-6 flex h-64 items-center justify-center">
          <Spinner className="h-8 w-8 text-brand-600" label="Loading" />
        </div>
      ) : isError || !data ? (
        <div className="mt-6 rounded-lg border border-dashed border-surface-border bg-surface p-8 text-center text-body text-text-muted">
          File not found.
        </div>
      ) : (
        <div className="mt-4 flex flex-col gap-6">
          <div>
            <h1 className="text-title font-semibold text-text">{data.fileName ?? "Unknown file"}</h1>
            <p className="mt-1 text-body text-text-muted">{data.folderPath ?? "—"}</p>
          </div>

          {data.investors.length === 0 ? (
            <div className="rounded-lg border border-dashed border-surface-border bg-surface p-8 text-center text-body text-text-muted">
              No investor has opened this file yet.
            </div>
          ) : (
            <div className="overflow-x-auto rounded-lg border border-surface-border bg-surface">
              <table className="w-full min-w-[560px] text-left">
                <thead>
                  <tr className="border-b border-surface-border text-meta text-text-muted">
                    <th className="px-3 py-2 font-medium">Investor</th>
                    <th className="px-3 py-2 font-medium">First opened</th>
                    <th className="px-3 py-2 font-medium">Last opened</th>
                    <th className="px-3 py-2 font-medium">Opens</th>
                    <th className="px-3 py-2 font-medium">Downloads</th>
                  </tr>
                </thead>
                <tbody>
                  {data.investors.map((inv) => (
                    <tr key={inv.userId} className="border-b border-surface-border last:border-0">
                      <td className="px-3 py-2 text-body">
                        <button
                          type="button"
                          onClick={() => navigate(`/analytics/users/${inv.userId}`)}
                          className="font-medium text-brand-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
                        >
                          {inv.displayName}
                        </button>
                      </td>
                      <td className="px-3 py-2 text-body text-text-muted">
                        {inv.firstOpened ? formatDateTime(inv.firstOpened) : "—"}
                      </td>
                      <td className="px-3 py-2 text-body text-text-muted">
                        {inv.lastOpened ? formatDateTime(inv.lastOpened) : "—"}
                      </td>
                      <td className="px-3 py-2 text-body text-brand-700">{inv.opens}</td>
                      <td className="px-3 py-2 text-body text-success-700">{inv.downloads}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </AnalyticsLayout>
  );
}
